// extracted by mini-css-extract-plugin
export default {"event":"Event_event__JWyEF","list":"Event_list__RHxK1","fadeIn":"Event_fadeIn__28Qt3","hoverLineLink":"Event_hoverLineLink__axFGJ"};